import { configureCognito } from '@codespeak11/cognito-passwordless';

const config = {
  userPoolId: import.meta.env.VITE_USER_POOL_ID || 'us-east-1_PCfRCmOyx',
  clientId: import.meta.env.VITE_SPA_CLIENT_ID || '42imonkotr0iv9sf4nmd3mop3m',
  apiUrl: import.meta.env.VITE_API_URL || 'https://personawiz.com/api/v1',
} as const;

const portalUrl = import.meta.env.VITE_SSO_PORTAL_URL || 'https://auth.braindance.net';
const cognitoDomain = import.meta.env.VITE_SSO_COGNITO_DOMAIN || 'https://braindance-auth-prod.auth.us-east-1.amazoncognito.com';
const siteOrigin = typeof window !== 'undefined' ? window.location.origin : 'https://personawiz.com';

configureCognito({
  userPoolId: config.userPoolId,
  clientId: config.clientId,
  sso: {
    role: 'client',
    portalUrl,
    cognitoDomain,
    callbackUrl: `${siteOrigin}/auth/callback`,
    signOutUrl: siteOrigin,
    scopes: ['openid', 'email', 'profile'],
  },
});

export { config };
